import React, {useState} from 'react';
import _ from 'lodash';
import TransitionExpand from './TransitionExpand';
import classes from './index.css';
import { div, span } from 'prelude-ls';

export default function CompletedCourseGrades(props){
    // console.log('completed course grades props');
    // console.log(props);
    const [displayCats, setDisplayCats] = useState( () =>{
        var displayCatz = {};
        Object.keys(props.courseGradeCats).forEach(gcid => {
            displayCatz[props.courseGradeCats[gcid].category.id]=false
        })
        return displayCatz;
    })
    const [showAllCats, setShowAllCats] = useState(false);

    const get_final_grade_pct = (final_grade) => {
        var rawmax=final_grade.rawgrademax
            var earned=final_grade.finalgrade
            //console.log (rawmax)
            //console.log (earned)
            if(rawmax == 0){
                rawmax = 1
            }
            var pct = Math.round(100 * earned / rawmax)
            //console.log(pct)
            return pct
    }

    const toggleDisplayCat = (catid) => {
        // console.log('are we clicking?')
        var tempCats = {...displayCats};
        // console.log(tempCats);
        tempCats[catid] = !tempCats[catid];
        setDisplayCats(tempCats);
    }
    const toggleAllGradeCats = () => {
        var tempCats = displayCats;
        Object.keys(tempCats).forEach( catid => {
            tempCats[catid] = !showAllCats;
        })
        setDisplayCats(tempCats);
        setShowAllCats(!showAllCats);
    }

    // console.log({grades_props: props, grades_state: {displayCats: displayCats, showAllCats: showAllCats}})

    return(
        <div className={classes.centerContents}>
            <div className={classes.finalgrade}>
                {get_final_grade_pct(props.finalScore)}%
                {showAllCats ? (
                    <span
                        className={classes.showGrade + ' ' + classes.allGrades + ' ' + classes.noPrint}
                        onClick={() => { console.log('be clicked'); toggleAllGradeCats()}}
                    >
                        hide grades in <br/>all Categories
                    </span>
                    
                ): (
                    <span
                        className={classes.hideGrade + ' ' + classes.allGrades + ' ' + classes.noPrint }
                        onClick={() => {console.log('be clicked');  toggleAllGradeCats()}}
                    >
                        show scores in <br/> all Categories
                    </span>
                )}
            </div>
            <div className={classes.gradetable}>
                {Object.keys(props.courseGradeCats).map( (cgcid, kee) => {
                    var cat = props.courseGradeCats[cgcid];
                    var klas = !displayCats[cat.category.id] ? classes.noPrint : '';
                    if(cat.grade_item.itemtype != 'course' && cat.final_score.aggregationstatus == 'used'){
                        return(
                            <div
                                className={classes.gradecat + ' ' + klas}
                                key={kee}
                            >
                                <TransitionExpand duration={500} height={cat.grade_item.itemtype != 'course' && cat.final_score.aggregationstatus == 'used' ? 'auto' : 0}>
                                    <p>
                                        {cat.category.fullname + " "}
                                        {displayCats[cat.category.id] ?
                                            (
                                                <span>
                                                    {get_final_grade_pct(cat.final_score)}% <br></br>
                                                    <span className={classes.hideGrade + ' ' + classes.noPrint}
                                                        onClick={() => {toggleDisplayCat(cat.category.id)}}
                                                        >
                                                        hide score
                                                    </span>                                                    
                                                </span>
                                            ):
                                            (
                                                <span className={classes.showGrade + ' ' + classes.noPrint}
                                                    onClick={() => toggleDisplayCat(cat.category.id)}>
                                                    show score
                                                </span>
                                            )
                                        }
                                    </p>
                                </TransitionExpand>
                            </div>
                        )
                    }
                })}
                
            </div>
        </div>
    )
}